var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 32,
    viewBox: "0 0 73 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31C3.47997 28.8146 16.3336 14.0087 20.2915 16.4233C23.1023 18.1381 21.1324 25.3546 25.985 24.9172C31.2353 24.444 33.7695 18.386 38.6986 17.3001C41.2172 16.7452 43.9253 17.6583 46.4374 16.9713C53.6784 14.991 54.7623 7.36869 59.0503 2.17303C62.803 -2.37397 66.507 8.0069 72 4.54151",
    stroke: "#22C55E",
    strokeWidth: 1.30564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitLine);
export default __webpack_public_path__ + "static/media/profit-line.75899e5a459435d7c300230935932316.svg";
export { ForwardRef as ReactComponent };